import { useTranslation } from 'react-i18next';

import { Button, Modal } from '@hotjar/hotsauce';

export interface RemovalConfirmationProps {
  isVisible: boolean;
  isThread: boolean;
  onConfirm: () => void;
  onAbort: () => void;
  threadBodyText?: string;
  threadHeaderText?: string;
}

export const RemovalConfirmation = ({
  isThread,
  isVisible,
  onAbort,
  onConfirm,
  threadBodyText,
  threadHeaderText,
}: RemovalConfirmationProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      contentLabel={t('comment:remove.confirmation.header')}
      hideCloseButton={false}
      isOpen={isVisible}
      onClose={onAbort}
    >
      <Modal.Header
        title={(isThread ? threadHeaderText : undefined) ?? t('comment:remove.confirmation.header')}
      />
      <Modal.Body>
        <p>
          {isThread
            ? threadBodyText ?? t('comment:remove.confirmation.body.thread')
            : t('comment:remove.confirmation.body.reply')}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={onAbort}>
          {t('comment:remove.confirmation.abort')}
        </Button>
        <Button kind="danger" onClick={onConfirm} type="submit" data-testid="confirm">
          {t('comment:remove.confirmation.confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
